<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Generate Document</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type"
            placeholder="Please Select"
            v-model="form.type"
            label="Document Type"
            :options="generatableTypes"
            :required="true"
            :show-error="form.errors.has('type')"
            helper="Please select the type of document to generate"
            :error-message="form.errors.get('type')"
            key-name="identifier"
          ></selectlist>

          <input-block
            name="description"
            label="Description"
            v-model="form.description"
            helper="Please enter a description for the document you are generating"
          ></input-block>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" v-on:clicked="generate"
        >Generate Document</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    types: {
      type: Array,
      required: true
    }
  },

  computed: {
    generatableTypes() {
      return this.types.filter(type => type.generator);
    }
  },

  data() {
    return {
      form: new window.Form({
        type: null,
        description: null
      })
    };
  },

  methods: {
    closeModal() {
      this.form.reset();
      this.$emit('close');
    },

    generate() {
      this.form
        .post('/incidents/' + this.incident + '/documents/generate')
        .then(response => {
          this.$emit('generated', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Oops, there was an error generating the documents'
          );
        });
    }
  }
};
</script>
